import { Controller } from '@hotwired/stimulus';

export default class AdvizePendingActionController extends Controller {
  static values = { url: String }

  dismiss() {
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        'Accept': 'application/json',
      },
    });
  }
}
